'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Portal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash.debounce');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYCODES = {
  ESCAPE: 27,
  DOWN: 40,
  UP: 38,
  ENTER: 13,
  SPACE: 32
};

var Portal = exports.Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    var _this = _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this));

    _this.state = { active: false };
    _this.handleWrapperClick = _this.handleWrapperClick.bind(_this);
    _this.closePortal = _this.closePortal.bind(_this);
    _this.openPortal = _this.openPortal.bind(_this);
    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
    _this.handleOpenOnKeydowns = _this.handleOpenOnKeydowns.bind(_this);
    _this.handleCloseKeydowns = _this.handleCloseKeydowns.bind(_this);
    _this.handleResizeClose = (0, _lodash2.default)(_this.handleResizeClose.bind(_this), 100);
    _this.portal = null;
    _this.node = null;
    _this.openOnClickElement = null;
    _this.openedByKeyPress = null;
    return _this;
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.closeOnEsc) {
        document.addEventListener('keydown', this.handleCloseKeydowns);
      }

      if (this.props.closeOnResize) {
        window.addEventListener('resize', this.handleResizeClose);
      }

      if (this.props.openOnDownArrow || this.props.openOnUpArrow) {
        document.addEventListener('keydown', this.handleOpenOnKeydowns);
      }

      if (this.props.closeOnOutsideClick) {
        document.addEventListener('mouseup', this.handleOutsideMouseClick);
        document.addEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.isOpened) {
        this.openPortal();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // portal's 'is open' state is handled through the prop isOpened
      if (typeof newProps.isOpened !== 'undefined') {
        if (newProps.isOpened) {
          if (this.state.active) {
            this.renderPortal(newProps);
          } else {
            this.openPortal(newProps);
          }
        }
        if (!newProps.isOpened && this.state.active) {
          this.closePortal();
        }
      }

      // portal handles its own 'is open' state
      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
        this.renderPortal(newProps);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.closeOnEsc) {
        document.removeEventListener('keydown', this.handleCloseKeydowns);
      }

      if (this.props.closeOnOutsideClick) {
        document.removeEventListener('mouseup', this.handleOutsideMouseClick);
        document.removeEventListener('touchstart', this.handleOutsideMouseClick);
      }

      if (this.props.closeOnResize) {
        window.removeEventListener('resize', this.handleDebounce);
      }

      if (this.props.openOnDownArrow || this.props.openOnUpArrow) {
        document.removeEventListener('keydown', this.handleOpenOnKeydowns);
      }

      this.closePortal(true);
    }
  }, {
    key: 'handleResizeClose',
    value: function handleResizeClose() {
      if (this.state.active) {
        this.closePortal();
      }
    }
  }, {
    key: 'handleWrapperClick',
    value: function handleWrapperClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.state.active) {
        if (this.props.openByClickOn && this.props.closeOnTriggerClick) {
          this.closePortal();
        } else {
          return;
        }
      } else {
        this.openPortal();
      }
    }
  }, {
    key: 'openPortal',
    value: function openPortal() {
      var _this2 = this;

      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

      this.setState({ active: true }, function () {
        _this2.renderPortal(props);
        _this2.props.onOpen(_this2.node);
      });
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      var _this3 = this;

      var isUnmounted = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.openedByKeyPress = false;
      var resetPortalState = function resetPortalState() {
        if (_this3.node) {
          _reactDom2.default.unmountComponentAtNode(_this3.node);
          document.body.removeChild(_this3.node);
        }
        _this3.portal = null;
        _this3.node = null;
        if (isUnmounted !== true) {
          _this3.setState({ active: false });
        }
      };

      if (this.state.active) {
        if (this.props.beforeClose) {
          this.props.beforeClose(this.node, resetPortalState);
        } else {
          resetPortalState();
        }

        this.props.onClose();
      }
    }
  }, {
    key: 'handleOutsideMouseClick',
    value: function handleOutsideMouseClick(e) {
      if (!this.state.active || e.currentTarget.activeElement === this.openOnClickElement) {
        return;
      }

      var root = (0, _reactDom.findDOMNode)(this.portal);
      if (root.contains(e.target) || e.button && e.button !== 0) {
        return;
      }

      e.stopPropagation();
      this.closePortal();
    }
  }, {
    key: 'handleCloseKeydowns',
    value: function handleCloseKeydowns(e) {
      if (e.keyCode === KEYCODES.ESCAPE && this.state.active && this.props.closeOnEsc) {
        this.closePortal();
      }
    }
  }, {
    key: 'handleOpenOnKeydowns',
    value: function handleOpenOnKeydowns(e) {
      // If we are not using openOnClickElement you have to manage keycodes yourself.
      if (!this.openOnClickElement) {
        return;
      }
      // If we are not the current focused item in document nothing will happen.
      if (this.openOnClickElement !== document.activeElement) {
        return;
      }
      if (this.props.openOnUpArrow && e.keyCode === KEYCODES.UP) {
        e.preventDefault();
        this.openedByKeyPress = KEYCODES.UP;
        this.openPortal();
      }
      if (this.props.openOnDownArrow && e.keyCode === KEYCODES.DOWN) {
        e.preventDefault();
        this.openedByKeyPress = KEYCODES.DOWN;
        this.openPortal();
      }
      if (e.keyCode === KEYCODES.ENTER || e.keyCode === KEYCODES.SPACE) {
        this.openedByKeyPress = e.keyCode;
      }
    }
  }, {
    key: 'renderPortal',
    value: function renderPortal(props) {
      if (!this.node) {
        this.node = document.createElement('div');
        document.body.appendChild(this.node);
      }

      var children = props.children;
      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
      if (typeof props.children.type === 'function') {
        children = _react2.default.cloneElement(props.children, {
          closePortal: this.closePortal,
          openedByKeyPress: this.openedByKeyPress
        });
      }

      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.node, this.props.onUpdate);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      if (this.props.openByClickOn) {
        return _react2.default.cloneElement(this.props.openByClickOn, {
          onClick: this.handleWrapperClick,
          ref: function ref(node) {
            // Keep your own reference
            _this4.openOnClickElement = node;
            // Call the original ref, if any
            var ref = _this4.props.openByClickOn.ref;

            if (typeof ref === 'function') {
              ref(node);
            }
          }
        });
      }
      return null;
    }
  }]);

  return Portal;
}(_react2.default.Component);

Portal.propTypes = {
  children: _propTypes2.default.element.isRequired,
  openByClickOn: _propTypes2.default.element,
  isOpened: _propTypes2.default.bool,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  beforeClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func,

  closeOnEsc: _propTypes2.default.bool,
  closeOnOutsideClick: _propTypes2.default.bool,
  closeOnResize: _propTypes2.default.bool,
  closeOnTriggerClick: _propTypes2.default.bool,

  openOnDownArrow: _propTypes2.default.bool,
  openOnUpArrow: _propTypes2.default.bool
};

Portal.defaultProps = {
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  onUpdate: function onUpdate() {}
};



//////////////////
// WEBPACK FOOTER
// ../player-react-portal/build/portal.js
// module id = 136
// module chunks = 0 1